module.exports = __webpack_public_path__ + "img/icon-pie.8a3bc3fe.svg";